import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Urbaniaonrentinpune() {



  const cardData =
  {
    keyword: 'Urbania on Rent in Pune',
    heading: 'Sai Trupti Cabs: Urbania on Rent in Pune',
    headingDescription: 'Sai Trupti Cabs offers reliable and comfortable Urbania on rent in Pune services, designed to make your group or family travel smooth and stress-free. Our fleet includes well-maintained, air-conditioned Force Urbania vans — all equipped with clean interiors, spacious seating configurations and ample luggage space. Every trip is driven by a professional, background-verified chauffeur who ensures punctual pickup anywhere in Pune, courteous service, and safe, smooth driving throughout your journey. With transparent rental fares, flexible booking options (one-way or round-trip, local or out-station), and 24×7 customer support, Sai Trupti Cabs makes your Urbania rental in Pune convenient, affordable and worry-free.',

    top: 'Top Places to Visit in Pune with Sai Trupti Cabs',

"topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "Shaniwar Wada is the crown jewel of Pune’s Maratha heritage, built in 1732 by the Peshwas as the seat of their empire. Once a magnificent seven-storey palace, its grand gates, carved teak balconies, and sprawling courtyards reflect royal elegance and political power. Though much of it was destroyed by fire, the fort’s ruins still whisper tales of valor, intrigue, and sacrifice. The evening light-and-sound show revives the Peshwa era through mesmerizing narration and music. Shaniwar Wada remains the emotional heart of Pune — where history, culture, and pride unite."
  },
  {
    "title": "Aga Khan Palace",
    "description": "Aga Khan Palace stands as an enduring symbol of India’s freedom movement and Mahatma Gandhi’s legacy. Built in 1892 by Sultan Aga Khan III, the palace later became a place of internment for Gandhi, Kasturba Gandhi, and other leaders during the Quit India Movement. The tranquil gardens, memorials, and museum preserve their memories and personal belongings. Its elegant Italian arches and serene ambiance make it both a historical monument and a place of reflection. Every corner tells a story of sacrifice, resilience, and the unbreakable spirit of India’s struggle for independence."
  },
  {
    "title": "Sinhagad Fort",
    "description": "Perched atop the rugged Sahyadri ranges, Sinhagad Fort is a timeless symbol of Maratha courage and pride. The fort gained fame after the legendary battle led by Tanaji Malusare under the command of Chhatrapati Shivaji Maharaj. Trekking up its steep slopes rewards visitors with panoramic views of the valley and Pune city. The fort’s stone walls, ancient gates, and rustic stalls serving pithla-bhakri bring history to life. Sinhagad is not just a fortress — it’s an experience of heritage, adventure, and the indomitable spirit of the Marathas."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "Pataleshwar Cave Temple is a fascinating 8th-century rock-cut shrine carved from basalt, dedicated to Lord Shiva. Located in the heart of Pune, it offers a peaceful escape from city noise and chaos. The circular Nandi mandapa, massive stone pillars, and unfinished sanctum reflect remarkable ancient craftsmanship. Believed to have been excavated during the Rashtrakuta dynasty, the temple’s spiritual aura attracts devotees and historians alike. Amid modern Pune’s growth, Pataleshwar stands as a reminder of its deep and timeless spiritual roots."
  },
  {
    "title": "Parvati Hill and Temple",
    "description": "Parvati Hill rises gracefully over Pune, offering both divine blessings and breathtaking views. The temple complex atop the hill is dedicated to Lord Shiva and Goddess Parvati and was built by the Peshwas in the 18th century. Climbing its 108 stone steps is both a spiritual and meditative experience, rewarded by panoramic views of the city below. The site also houses the Peshwa Museum, which preserves rare artifacts of Maratha glory. At sunrise and sunset, Parvati Hill becomes a golden haven of peace, history, and devotion."
  },
  {
    "title": "Dagdusheth Halwai Ganpati Temple",
    "description": "The Dagdusheth Halwai Ganpati Temple is Pune’s most beloved spiritual landmark, drawing millions of devotees each year. The temple’s magnificent idol of Lord Ganesha, adorned with gold ornaments and fresh flowers, radiates devotion and positivity. During Ganesh Chaturthi, the entire area transforms into a festival of lights, music, and prayer. The temple also supports charitable causes, embodying the true essence of faith in action. Whether you visit for blessings or simply to soak in its energy, Dagdusheth Temple fills every heart with peace and joy."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "Raja Dinkar Kelkar Museum is a treasure house of Indian art and tradition, housing over 20,000 artifacts collected by the late Dr. Dinkar Kelkar. Its exhibits include intricate musical instruments, ancient sculptures, traditional ornaments, and everyday objects that reveal India’s creative spirit. The museum’s highlight is the replica of a 17th-century Wada — a traditional Maharashtrian mansion. Walking through its corridors feels like stepping back in time. It’s a must-visit for art lovers, history enthusiasts, and anyone seeking to rediscover India’s cultural richness."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "Khadakwasla Dam, just 20 km from Pune, is a popular getaway surrounded by rolling hills and lush greenery. Built across the Mutha River, it serves as the city’s primary water source and a serene picnic spot for families and friends. Visitors enjoy the mesmerizing sunset reflecting off the calm waters while savoring local snacks from nearby stalls. During monsoon, the dam’s scenic charm doubles, making it a photographer’s paradise. It’s the perfect escape for those seeking peace, nature, and a cool breeze away from urban life."
  },
  {
    "title": "Osho International Meditation Resort",
    "description": "Located in Koregaon Park, Osho International Meditation Resort is a tranquil oasis that attracts visitors from across the globe. Spread over lush gardens and modern Zen-inspired architecture, it offers various meditation sessions, wellness therapies, and workshops on mindfulness. The serene environment encourages introspection and personal growth. Beyond being a retreat, Osho Resort reflects Pune’s cosmopolitan identity — blending spirituality, modernity, and holistic living. It’s where silence meets luxury, creating an experience that rejuvenates both body and soul."
  },
  {
    "title": "Pune Okayama Friendship Garden (Pu La Deshpande Udyan)",
    "description": "Inspired by Japan’s famous Korakuen Garden, the Pune Okayama Friendship Garden — also known as Pu La Deshpande Udyan — is an exquisite symbol of Indo-Japanese friendship. Spread across 10 acres, its winding paths, small bridges, ponds, and manicured lawns create a serene landscape ideal for relaxation and photography. The garden’s harmony between Japanese design and Indian flora makes it one of Pune’s most aesthetic green spaces. Families, nature lovers, and photographers visit to unwind amid its calming beauty and artistic symmetry."
  }
],



"services": [
    {
      "name": "Urbania on Rent in Pune",
      "description": "Rent an Urbania in Pune for comfortable local or outstation trips with AC/non-AC options, professional drivers, luggage support, flexible schedules, and transparent fares. Ideal for family outings and group travel."
    },
    {
      "name": "Pune Urbania Hire",
      "description": "Reliable Urbania rental service in Pune offering well-maintained vehicles, AC/non-AC options, professional drivers, luggage assistance, and affordable pricing for smooth local and long-distance travel."
    },
    {
      "name": "AC Urbania Rental Pune",
      "description": "Premium AC Urbania rental in Pune providing cool and comfortable rides with professional drivers, luggage support, flexible pickup/drop points, online booking, and transparent fares for families and corporate trips."
    },
    {
      "name": "Non AC Urbania Hire Pune",
      "description": "Budget-friendly non-AC Urbania rental in Pune with professional drivers, luggage assistance, flexible pickup/drop schedules, and transparent fares for economical local or outstation travel."
    },
    {
      "name": "Luxury Urbania Pune",
      "description": "Experience luxury travel with Urbania rental in Pune offering premium interiors, AC service, professional drivers, luggage support, and timely pickups. Perfect for weddings, corporate events, and VIP trips."
    },
    {
      "name": "Urbania for Corporate Trips Pune",
      "description": "Corporate Urbania hire in Pune providing AC/non-AC options, professional chauffeurs, luggage assistance, flexible pickup/drop schedules, online booking, and transparent fares for business travel."
    },
    {
      "name": "Urbania for Wedding Pune",
      "description": "Urbania rental in Pune for weddings ensuring comfort and luxury with AC/non-AC options, professional drivers, luggage support, timely pickups, and hassle-free travel for guests."
    },
    {
      "name": "Urbania for Family Trip Pune",
      "description": "Rent an Urbania in Pune for family trips with spacious seating, AC/non-AC options, professional drivers, luggage support, flexible pickup/drop points, and transparent fares for safe and comfortable travel."
    },
    {
      "name": "Urbania Outstation Booking Pune",
      "description": "Book an Urbania in Pune for outstation trips with AC/non-AC options, professional drivers, luggage support, flexible pickup/drop points, online booking, and transparent fares for hassle-free long-distance travel."
    },
    {
      "name": "Affordable Urbania Rental Pune",
      "description": "Budget-friendly Urbania rental in Pune offering AC/non-AC vehicles, professional drivers, luggage assistance, flexible schedules, and transparent fares for local, one-way, or outstation trips."
    },
    {
      "name": "Urbania Online Booking Pune",
      "description": "Book your Urbania online in Pune instantly with secure payments, AC/non-AC options, professional drivers, luggage support, flexible pickup/drop points, and transparent fares for convenient travel."
    },
    {
      "name": "Urbania Hire Near Me Pune",
      "description": "Find Urbania rental near your location in Pune for quick and convenient booking. Includes AC/non-AC options, professional drivers, luggage assistance, flexible schedules, and affordable fares."
    },
    {
      "name": "Best Urbania Rental Pune",
      "description": "Top-rated Urbania rental in Pune providing well-maintained vehicles, AC/non-AC options, professional drivers, luggage assistance, flexible pickup/drop points, and reliable service for local and outstation travel."
    },
    {
      "name": "Urbania 14/16/17 Seater Pune",
      "description": "Hire a 14/16/17 seater Urbania in Pune for large group travel with AC/non-AC options, professional drivers, luggage support, flexible pickup/drop points, and transparent fares for comfortable and safe rides."
    },
    {
      "name": "Pune Urbania Van Hire",
      "description": "Urbania van rental in Pune offering spacious seating for large groups, AC/non-AC options, professional drivers, luggage assistance, flexible schedules, and transparent fares for family trips, corporate travel, or events."
    }
  ],
  "tableData": [
    ["Urbania on Rent in Pune", "Pune Urbania Hire"],
    ["AC Urbania Rental Pune", "Non AC Urbania Hire Pune"],
    ["Luxury Urbania Pune", "Urbania for Corporate Trips Pune"],
    ["Urbania for Wedding Pune", "Urbania for Family Trip Pune"],
    ["Urbania Outstation Booking Pune", "Affordable Urbania Rental Pune"],
    ["Urbania Online Booking Pune", "Urbania Hire Near Me Pune"],
    ["Best Urbania Rental Pune", "Urbania 14/16/17 Seater Pune"],
    ["Pune Urbania Van Hire", ""]
  ],


"whychoose": [
  {
    "WhyChooseheading": "Urbania on Rent in Pune",
    "WhyChoosedescription": "Sai Trupti Cabs Pvt Ltd offers reliable and comfortable rental services for the spacious and versatile Force Urbania minivan in Pune—ideal for group outings, corporate events, family trips or airport transfers."
  },
  {
    "WhyChooseheading": "Transparent & Competitive Pricing",
    "WhyChoosedescription": "Our rental rates for the Urbania in Pune start at approx. ₹35‑₹40 per km for a 13‑seater, and around ₹37‑₹38 per km or ~₹10,000 per day for a 17‑seater, inclusive of driver, but exclusive of toll/parking. :contentReference[oaicite:turn0search6]{index=1}"
  },
  {
    "WhyChooseheading": "Spacious, Multi‑Seater Facility",
    "WhyChoosedescription": "The Urbania offers ample seating (9‑13‑17 seats) plus large luggage capacity—making it perfect for group travel across Pune, inter‑city transfers or day trips."
  },
  {
    "WhyChooseheading": "Professional & Experienced Drivers",
    "WhyChoosedescription": "Our courteous, skilled drivers are trained for group‑vehicle management, familiar with Pune and neighbouring routes, and ensure a safe, smooth and timely journey."
  },
  {
    "WhyChooseheading": "Flexible Pickup & Drop Locations",
    "WhyChoosedescription": "We provide convenient pickups across Pune city (including airport, hotels, suburbs) and drop‑offs at your preferred location—whether local or outstation."
  },
  {
    "WhyChooseheading": "Clean, Well‑Maintained Vehicles",
    "WhyChoosedescription": "Each Urbania minivan in our fleet is regularly serviced, sanitized and equipped for comfort—ideal for your group’s travel needs."
  },
  {
    "WhyChooseheading": "24/7 Booking & Customer Support",
    "WhyChoosedescription": "Our dedicated support team is available round the clock to assist with bookings, route planning, vehicle dispatch and any travel‑related queries."
  },
  {
    "WhyChooseheading": "Easy & Hassle‑Free Booking Process",
    "WhyChoosedescription": "Book your Urbania in Pune easily via call, WhatsApp or our website—choose your date, seating capacity, distance and get instant confirmation."
  }
]

















  }

const faqData = [
  {
    question: 'Does Sai Trupti Cabs Pvt Ltd offer Force Urbania on rent in Pune?',
    answer: 'Yes, Sai Trupti Cabs Pvt Ltd offers the Force Urbania on rent in Pune for group travel, outstation trips, airport transfers and more.',
  },
  {
    question: 'How can I rent a Force Urbania in Pune with Sai Trupti Cabs?',
    answer: 'You can easily book a Force Urbania rental through our website, mobile app, or by contacting our 24×7 customer support team.',
  },
  {
    question: 'What types of rental packages are available for the Force Urbania in Pune?',
    answer: 'We provide flexible rental packages for the Force Urbania including hourly/local, full‑day, and outstation options to suit your group size and travel needs.',
  },
  {
    question: 'What are typical rental rates for the Force Urbania in Pune?',
    answer: 'Our Force Urbania rentals in Pune start at approximately **₹ 34‑₹ 38 per km** for 13‑17 seater models, and day‑minimum packages from around **₹ 7,500‑₹ 10,000** for local use. :contentReference[oaicite:2]{index=2}',
  },
  {
    question: 'What payment methods are accepted for Force Urbania rental bookings?',
    answer: 'We accept payments via UPI, credit/debit cards, bank transfers and digital wallets for hassle‑free transactions.',
  },
  {
    question: 'What safety and hygiene protocols are followed for Force Urbania rentals in Pune?',
    answer: 'All our Force Urbania vehicles are well‑maintained, sanitized before every trip and driven by trained professional drivers to ensure a safe and comfortable journey.',
  },
  {
    question: 'Is customer support available during the Force Urbania rental period?',
    answer: 'Yes, our 24×7 customer support team is available to assist you throughout your Force Urbania rental period in Pune.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Rajesh Kulkarni',
    feedback: 'Rented a Force Urbania in Pune with Sai Trupti Cabs — the ride was very comfortable, the seats were great, and the driver was punctual.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Pooja Patwardhan',
    feedback: 'The Force Urbania rental with Sai Trupti Cabs was seamless. Excellent vehicle and friendly driver made our group outing very smooth.',
    rating: 5,
  },
];



















































































  const Images = [
  { place: "/images/keyword/1.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
  { place: "/images/keyword/2.jpg", text: "Pune to Mumbai Airport Cab", link: "Pune-to-Mumbai-Airport-Cab" },
  { place: "/images/keyword/3.jpg", text: "Pune to Mumbai International Airport Cab", link: "Pune-to-Mumbai-International-Airport-Cab" },
  { place: "/images/keyword/4.jpg", text: "Pune to Mumbai One Way Cab", link: "Pune-to-Mumbai-One-Way-Cab" },
  { place: "/images/keyword/5.jpg", text: "Pune Mumbai Car Hire", link: "Pune-Mumbai-Car-Hire" },
  { place: "/images/keyword/6.jpg", text: "Pune to Mumbai Taxi Fare", link: "Pune-to-Mumbai-Taxi-Fare" },
  { place: "/images/keyword/7.jpg", text: "Pune to Mumbai Online Cab Booking", link: "Pune-to-Mumbai-Online-Cab-Booking" },
  { place: "/images/keyword/8.jpg", text: "Pimpri Chinchwad to Mumbai Cab", link: "Pimpri-Chinchwad-to-Mumbai-Cab" },
  { place: "/images/keyword/9.jpg", text: "Baner to Mumbai Cabs", link: "Baner-to-Mumbai-Cabs" },
  { place: "/images/keyword/10.jpg", text: "Hinjewadi to Mumbai Cab", link: "Hinjewadi-to-Mumbai-Cab" },
  { place: "/images/keyword/11.jpg", text: "Pimple Saudagar to Mumbai Cab Service", link: "Pimple-Saudagar-to-Mumbai-Cab-Service" },
  { place: "/images/keyword/12.jpg", text: "Wakad to Mumbai Cab", link: "Wakad-to-Mumbai-Cab" },
  { place: "/images/keyword/13.jpg", text: "Hadapsar to Mumbai Cab", link: "Hadapsar-to-Mumbai-Cab" },
  { place: "/images/keyword/14.jpg", text: "Kalyani Nagar to Mumbai Taxi", link: "Kalyani-Nagar-to-Mumbai-Taxi" },
  { place: "/images/keyword/15.jpg", text: "Koregaon Park to Mumbai Cab", link: "Koregaon-Park-to-Mumbai-Cab" },
  { place: "/images/keyword/16.jpg", text: "Kothrud to Mumbai Cab", link: "Kothrud-to-Mumbai-Cab" },
  { place: "/images/keyword/17.jpg", text: "Kharadi to Mumbai Cab", link: "Kharadi-to-Mumbai-Cab" },
  { place: "/images/keyword/18.jpg", text: "Shivajinagar to Mumbai Cab", link: "Shivajinagar-to-Mumbai-Cab" },
  { place: "/images/keyword/19.jpg", text: "Pune to Mumbai Ertiga Cab", link: "Pune-to-Mumbai-Ertiga-Cab" },
  { place: "/images/keyword/20.jpg", text: "Pune to Mumbai Innova Crysta Cab", link: "Pune-to-Mumbai-Innova-Crysta-Cab" },
  { place: "/images/keyword/21.jpg", text: "Pune to Mumbai Sedan Cab", link: "Pune-to-Mumbai-Sedan-Cab" },
  { place: "/images/keyword/22.jpg", text: "Kondhwa to Mumbai Cab", link: "Kondhwa-to-Mumbai-Cab" },
  { place: "/images/keyword/23.jpg", text: "Viman Nagar to Mumbai Cabs", link: "Viman-Nagar-to-Mumbai-Cabs" },
  { place: "/images/keyword/24.jpg", text: "Katraj to Mumbai Cab Service", link: "Katraj-to-Mumbai-Cab-Service" },
  { place: "/images/keyword/25.jpg", text: "Pune Station to Mumbai Cabs Service", link: "Pune-Station-to-Mumbai-Cabs-Service" },
];















const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Urbania on Rent in Pune",
  "image": "https://saitrupticabs.com/assets/images/urbania-pune.jpg",
  "description": "Rent an Urbania van in Pune for corporate trips, weddings, family trips, or outstation travel. Available in AC and Non-AC options with 14/16/17-seater capacity. Book online at affordable rates for a comfortable journey.",
  "brand": {
    "@type": "Brand",
    "name": "Sai Trupti Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "8945"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "3999",
    "availability": "https://schema.org/InStock",
    "url": "https://saitrupticabs.com/urbania-on-rent-pune"
  }
};




  return (
    <div>
      
<Helmet>
  <title>Urbania on Rent in Pune | AC & Non-AC | Sai Trupti Cabs</title>
  <meta 
    name="description" 
    content="Rent an Urbania van in Pune for corporate trips, weddings, family trips, or outstation travel. Available in AC and Non-AC options with 14/16/17-seater capacity. Book online at affordable rates for a comfortable journey." 
  />
  <meta 
    name="keywords" 
    content="Urbania on Rent in Pune, Pune Urbania Hire, AC Urbania Rental Pune, Non AC Urbania Hire Pune, Luxury Urbania Pune, Urbania for Corporate Trips Pune, Urbania for Wedding Pune, Urbania for Family Trip Pune, Urbania Outstation Booking Pune, Affordable Urbania Rental Pune, Urbania Online Booking Pune, Urbania Hire Near Me Pune, Best Urbania Rental Pune, Urbania 14/16/17 Seater Pune, Pune Urbania Van Hire" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
<section
      className="breadcrumb-section"
      style={{ backgroundImage: "url(/images/background/inner-banner-bg.png)" }}
    >
      <div className="container">
        <div className="banner-content">
          <h1> {cardData.keyword}</h1>
        </div>
      </div>
    </section>



      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/newimages/13.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sai Trupti Cabs</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sai Trupti Cabs </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+918390907004" className="pc-call">+91 8390907004</a>
                      <a href="tel:+919922727744" className="pc-call">+91 9922727744</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/918390907004"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+918390907004" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@saitrupticabs.com" className="pc-email">
                      booking@saitrupticabs.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sai Trupti Cabs </strong><br />
                      Yashoda splendid Park,
                      Office number D. Wing Dudulgaon Anandi,
                        ruial Sainath Chowk Alandi-412105
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Urbaniaonrentinpune;